// extracted by mini-css-extract-plugin
module.exports = {"select":"_3T3D3","commentText":"_3iHKB","comment":"_13tJu","new":"_2gIaq","commentInfo":"Ee4ww","timeSelector":"qjo_V","regularCommentInfo":"_2w2QY","subLabel":"_1QITn"};